export const QIKTRUCK_CONSUMER_SITE = "https://qiktruck.co.za";
export const QIKTRUCK_APP_STORE =
  "https://apps.apple.com/za/app/qiktruck-bakkie-truck-hire/id6741314137";
export const QIKTRUCK_PLAY_STORE =
  "https://play.google.com/store/apps/details?id=za.co.qiktruck";
